//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import abstract4 from '@/assets/imgs/abstract4.svg';
import footerAbstract from '@/assets/imgs/blog-footer-abstract.svg';
import { page } from '@/mixins/wp-post';

export default {
  name: 'KnockWorks',

  mixins: [page('works')],

  data() {
    return {
      category: 'All',
      footerAbstract,
      slideTransition: 'slide-next',
      sliderProjects: []
    };
  },

  computed: {
    headerBg() {
      return `background: #131212 url("${abstract4}") no-repeat scroll top right`;
    },

    filteredProjects() {
      if (this.category === 'All') {
        return this.sliderProjects;
      }

      const projects = this.sliderProjects.filter((project) => project.categories.indexOf(this.category) >= 0);

      return projects;
    }
  },

  mounted() {
    if (this.$route.hash) {
      let hash = this.$route.hash.substring(1);
      hash = hash.charAt(0).toUpperCase() + hash.slice(1);

      this.category = hash;
    }

    this.sliderProjects = this.page.acf.projects.map((obj) => ({ ...obj, slide: 0 }));
  },

  methods: {
    setCat(cat) {
      this.category = cat;
    },

    next(project) {
      this.slideTransition = 'slide-next';

      if (project.slide < project.thumbnails.length - 1) {
        project.slide += 1;
      }
      else {
        project.slide = 0;
      }

      console.log(`Slide: ${project.slide}`);
    },

    prev(project) {
      this.slideTransition = 'slide-prev';

      if (project.slide > 0) {
        project.slide -= 1;
      }
      else {
        project.slide = project.thumbnails.length - 1;
      }

      console.log(`Slide: ${project.slide}`);
    }
  }

};
